import { AdminSidebar } from './AdminSidebar';
import { AdminBottomNav } from './AdminBottomNav';
import { AdminFAB } from './AdminFAB';
import { Outlet, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import { RegenLogo } from './RegenLogo';
import { useAuth } from '@/lib/auth';

export function AdminShell() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[var(--c-bg)]">
      <AdminSidebar open={open} onClose={() => setOpen(false)} />

      {/* Mobile top header */}
      <div className="lg:hidden sticky top-0 z-20 glass border-b border-[var(--c-hair)] px-4 py-3 flex items-center justify-between">
        <button onClick={() => setOpen(true)} data-testid="admin-hamburger" className="w-10 h-10 -ml-2 rounded-full hover:bg-[var(--c-film)] flex items-center justify-center">
          <Menu className="w-5 h-5" />
        </button>
        <RegenLogo size="sm" />
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#00C8FF] to-[var(--c-green)] flex items-center justify-center text-[#081726] font-bold text-xs">
          {(user?.name || 'JP').split(' ').map(p => p[0]).slice(0,2).join('')}
        </div>
      </div>

      <main className="lg:ml-64 px-4 lg:px-8 py-5 lg:py-8 pb-32 lg:pb-12 animate-fade-up">
        <Outlet />
      </main>

      <AdminBottomNav onMore={() => setOpen(true)} />
      <AdminFAB />
    </div>
  );
}
